module.exports = __webpack_public_path__ + "media/images/lp/industries/feature-02-84c8bdbbc47738917b1b47c01c5d654b.png";